module.exports = __webpack_public_path__ + "static/media/black-tshirt-front-min.ae141189.png";